import { user, roles } from "@Modules/User/configs/constants";

import list_user from "./reducers";
import list_role from "./reducers/rolesSelect";

export default {
  [user]: list_user,
  [roles]: list_role,
};
